const DeleteIcon = ({ fill = "#F85963" }: any) => (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.429 13.185c0 .815.686 1.481 1.524 1.481h6.095c.838 0 1.524-.666 1.524-1.481V5.777c0-.814-.686-1.481-1.524-1.481H4.953c-.838 0-1.524.667-1.524 1.481v7.408Zm9.143-11.111h-1.905l-.541-.526a.78.78 0 0 0-.533-.215H6.408a.78.78 0 0 0-.533.215l-.541.526H3.429a.754.754 0 0 0-.762.74c0 .408.343.741.762.741h9.143a.754.754 0 0 0 .762-.74.754.754 0 0 0-.762-.741Z"
            fill={fill}
        />
    </svg>
)

export default DeleteIcon
